import React from "react";
import { StyleSheet, View } from "react-native";

import { createStackNavigator } from "@react-navigation/stack";
import { VoucherScreen, PasswordScreen, ProfileScreen, SettingsScreen} from "../screens/settings";

const Tab = createStackNavigator();

export default function SettingsNavigator() {
  return (
    <View style={styles.container}>
      <Tab.Navigator headerMode="none">
        <Tab.Screen
          name="Settings"
          component={SettingsScreen}
          options={{
            title: "Settings",
          }}
        />
        <Tab.Screen
          name="Profile"
          component={ProfileScreen}
          options={{
            title: "Profile",
          }}
        />
        <Tab.Screen
          name="Password"
          component={PasswordScreen}
          options={{
            title: "Update Password",
          }}
        />
        <Tab.Screen
          name="Voucher"
          component={VoucherScreen}
          options={{
            title: "Voucher",
          }}
        />
      </Tab.Navigator>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
